import styles from "./DevelopmentFinanceBlogs.module.scss";
import Footer from "../../components/Footer";
import CompareContainer3 from "../../components/CompareContainer/CompareContainer3";
import TypeOfRequirements from "../../components/TypeOfRequirements";
import MatchingMortgages3 from "../../components/MatchingMortgages/MatchingMortgages3";
import NewsContainer from "../../components/NewsContainer";
import LoanApplication3 from "../../components/LoanApplication/LoanApplication3";
import { useEffect } from "react";
import HeroSection from "../../components/HeroSection/HeroSection";
import TestimonialsContainer from "../../components/TestimonialsContainer";
const DevelopmentFinanceBlogs3 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className={styles.developmentFinanceBlogs}>
      <HeroSection title="Development Finance" />
      <CompareContainer3 title="Development Finance" />
      <TypeOfRequirements title="Development Finance" />
      <MatchingMortgages3 title="Development Finance" />
      <NewsContainer title="Development Finance" />
      <LoanApplication3 title="Development Finance" />
      <TestimonialsContainer title="Development Finance" />
      <Footer title="Development Finance" />
    </div>
  );
};

export default DevelopmentFinanceBlogs3;
